module.exports = __webpack_public_path__ + "static/media/video-video-vimeo-icon-svgrepo-com.2d97df24.svg";